// Brand palette for Clerk's SignIn / UserProfile widgets. Keep in sync
// with the transactional emails in Ilan26.Back/tools/ClerkMigration/emails
// (#5c2dd3 is the Ila26 purple used there and in the marketing site).
// Split into its own module so a future dark-mode wiring can swap the
// `variables` block without touching the SignInPage component.
//
// Type left inferred: @clerk/react does not re-export its `Appearance`
// type at the module boundary, and the object literal shape TypeScript
// infers here is a superset assignable to Clerk's `appearance` props.
const ILA26_PURPLE = "#5c2dd3";

export const ila26ClerkAppearance = {
    variables: {
        colorPrimary: ILA26_PURPLE,
        colorText: "#1c1c1e",
        colorBackground: "#ffffff",
        borderRadius: "8px",
        fontFamily: "Inter, Roboto, system-ui, -apple-system, sans-serif",
    },
    elements: {
        card: { boxShadow: "0 6px 24px rgba(28, 28, 30, 0.08)" },
        formButtonPrimary: {
            textTransform: "none",
            fontWeight: 600,
        },
        footerAction: { display: "none" },
    },
};
